import CandidateNotesPageContent from '@/components/CandidateNotesPageContent';
import { PersonType } from '@/types/api';

type Props = {
  candidate: PersonType;
  refetchCandidate?: () => void;
};

const StaffMemberNotes = ({ candidate, refetchCandidate }: Props): JSX.Element => {
  return <CandidateNotesPageContent candidate={candidate} onRefetchCandidate={refetchCandidate} />;
};

export default StaffMemberNotes;
